import { render, staticRenderFns } from "./FinancePaymentIndex.vue?vue&type=template&id=3ff006c8&scoped=true&"
import script from "./FinancePaymentIndex.vue?vue&type=script&lang=js&"
export * from "./FinancePaymentIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff006c8",
  null
  
)

export default component.exports